<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item>
						<template>
							<!-- <el-button type="primary" @click="search">搜索</el-button>
	                        <el-button type="primary" @click="empty">清空</el-button> -->
							<el-button type="primary" @click="editialogVisible('')">新增
							</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="feedbackTypeList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="typeName" label="类型名称" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="typeImg" label="类型图标" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img v-if="scope.row.typeImg" :src="scope.row.typeImg" width="50px" />
					<div v-else> 暂无图片 </div>
				</template>
			</el-table-column>

			<el-table-column prop="updateTime" label="修改时间" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.updateTime">{{scope.row.updateTime}}</div>
					<div v-else> 未修改 </div>
				</template>
			</el-table-column>

			<el-table-column prop="createTime" label="创建时间" align="center">
			</el-table-column>

			<el-table-column prop="isEnable" label="状态" align="center">
				<template slot-scope="scope">
					<p v-if="!scope.row.isEnable">禁用</p>
					<p v-else>启用</p>
				</template>
			</el-table-column>
			<el-table-column  label="操作"  fixed="right" align="center">
				　　　　<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					　　<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="feedbackTypeList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="feedbackTypeList.total"
			@size-change="handleSizeChange">
		</el-pagination>

		<!-- 查看 -->
		<el-dialog title="提示" :visible.sync="showContentDialog" width="50%">
			<span v-html="contentValue"></span>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="showContentDialog = false">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 编辑 -->
		<el-dialog style="float:rigin" :title="popupTitle" :visible.sync="editDialogVisible" width="50%" :close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">

					<el-form-item :label-width="formLabelWidth" label="消息类型名称:">
						<el-col :span="8">
							<el-input v-model="form.typeName" placeholder="请输入消息类型名称" />
						</el-col>
					</el-form-item>

					<el-form-item :label-width="formLabelWidth" label="类型图标:">
						<el-upload class="upload-demo" :action="migUrl" :on-preview="handlePreview" :on-success="onSuccess"
							:on-remove="handleRemove" :before-remove="beforeRemove" multiple :limit="1" :on-exceed="handleExceed"
							:file-list="fileList">
							<el-button size="small" type="primary">点击上传</el-button>
							<!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
						</el-upload>
					</el-form-item>

					<el-form-item :label-width="formLabelWidth" label="图标:">
						<template>
							<img v-if="form.typeImg" :src="form.typeImg" width="50px" />
							<div v-else>请上传图片</div>
						</template>
					</el-form-item>

					<el-form-item v-if="ids" label="是否启用">
						<el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false">
						</el-switch>
					</el-form-item>

					<el-form-item>
						<el-button :loading="toEditLoading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>


		</el-dialog>
	</div>
</template>

<script>
	import { uploadFileServer } from '@/api/axios.js'
	var urls = uploadFileServer('feedbacktype');

	import {
		quillEditor
	} from 'vue-quill-editor' //调用编辑器
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	export default {
		components: {
			//使用编辑器
			quillEditor
		},
		data() {
			return {
				migUrl: urls,
				fileList: [],
				loading: false,
				feedbackTypeList: [], //消息类型列表
				dialogVisible: false,
				editDialogVisible: false,
				form: {
					id: 0,
					code: "",
					typeName: "",
					typeNameEn: "",
					typeImg: ""
				},
				mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
				},
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				page: {
					pageNum: 1,
					pageSize: 10
				},
				searchInfo: {},
				index: null,
				contentValue: "",
				showContentDialog: false,
				popupTitle:'新增'
			};
		},
		computed: {
			editor() {
				return this.$refs.myQuillEditor.quill
			}
		},
		methods: {
			handleRemove(file, fileList) {
				//console.log(file, fileList);
			},
			handlePreview(file) {
				//console.log(file);
			},
			handleExceed(files, fileList) {
				this.$message.warning(`当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
			},
			beforeRemove(file, fileList) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			onSuccess(response, file, fileList) {
				// console.log(response);
				var form = {
					id: this.form.id,
					code: this.form.code,
					typeName: this.form.typeName,
					typeNameEn: this.form.typeNameEn,
					typeImg: response.message
				}
				this.form = form;
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.loading = true
				let webData = {
					pageNum: 1,
					pageSize: this.page.pageSize,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					username: this.searchInfo.username,
					changeType: this.searchInfo.changeType
				}
				this.$api.findByWhereFeedbackType(webData).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.messageTypeList = res.data
					}
					this.loading = false
				})
			},
			showContent(content) {
				this.contentValue = content
				this.showContentDialog = true
			},
			//编辑弹框
			editialogVisible(id) {
				this.fileList = []
				if (id) {
					this.popupTitle = '编辑'
					this.fileList = []
					//编辑查询
					this.ids = id
					this.form.timer = []
					let data = {
						pageNum: this.page.pageNum,
						pageSize: this.page.pageSize,
						id: id
					}
					this.$api.findByIdFeedbackType(data.id).then((res) => { //根据id查询反馈分类
						if (res.state == 'success') {
							this.form = res.data;
						}
					})
				} else {
					this.popupTitle = '新增'
					this.ids = ""
					this.form = {}
				}
				this.editDialogVisible = true;
			},
			toEdit() {
				this.toEditLoading = true;
				if (this.ids) {
					//编辑
					this.$api.updateFeedbackType(this.form).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getFeedbackTypeList(); //消息分类列表刷新
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				} else {
					//添加
					let data = {
						code: this.form.code,
						typeName: this.form.typeName,
						typeNameEn: this.form.typeNameEn,
						typeImg: this.form.typeImg
					};
					// console.log(data);
					this.$api.addFeedbackType(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getFeedbackTypeList();
						} else {
							this.$message.error(res.message);
						}
						this.toEditLoading = false;
					})
				}
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartStartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.startDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row.endDate);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getFeedbackTypeList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getFeedbackTypeList()
			},
			getFeedbackTypeList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize
				}
				this.$api.findByWhereFeedbackType(data).then((res) => { //反馈类型
					// console.log(res);
					if (res.state == 'success') {
						this.feedbackTypeList = res.data
						this.loading = false
					}
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.upIsDeleteFeedbackType(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getFeedbackTypeList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		},
		created() {
			this.getFeedbackTypeList();
		},
		mounted: function () { },
	};
</script>

<style scoped lang="less">
	// .redItem{
	// 	display: flex;
	// 	align-items: center;
	// 	justify-content: flex-start !important;
	// }
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>